
/* ============================================================================
FILE: po-katupirsia9-respiration-d-or-texts-fr-en-es-20260326.js
MODE: protected trilingual with FR / EN / ES buttons + lexicon locking + audio
API:  window.PoKatupirsia9RespirationDOrTextsFR_EN_ES_20260326
ROOT: .po-axis-section[data-po-axis='respiration_d_or']
============================================================================ */

(function(){
  "use strict";

  if (window.__PO_KATUPIRSIA9_RESPIRATION_D_OR_TEXTS_20260326__) return;
  window.__PO_KATUPIRSIA9_RESPIRATION_D_OR_TEXTS_20260326__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var ROOT_SEL = ".po-axis-section[data-po-axis='respiration_d_or']";

  var CONCEPT_URL  = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/respiration_d_or_conceptuel.png?v=1773258647";
  var FUNCTION_URL = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/respiration_d_or_fonctionnel.png?v=1773258647";

  function clampStr(v){ return (v == null) ? "" : String(v); }

  function normLang(raw){
    var s = clampStr(raw).toLowerCase().trim().replace(/_/g, "-");
    if (s.indexOf("es") === 0 || s.indexOf("pt") === 0) return "ES";
    if (s.indexOf("en") === 0) return "EN";
    return "FR";
  }

  function getBrowserLang(){
    var dl = document && document.documentElement ? (document.documentElement.getAttribute("lang") || "") : "";
    if (dl) return normLang(dl);
    if (typeof navigator !== "undefined"){
      if (navigator.languages && navigator.languages.length) return normLang(navigator.languages[0] || "fr");
      if (navigator.language) return normLang(navigator.language || "fr");
    }
    return "FR";
  }

  function readStoredLang(){
    try{
      var v = localStorage.getItem(STORAGE_KEY);
      return v ? normLang(v) : "";
    }catch(e){ return ""; }
  }

  function storeLang(lang3){
    try{ localStorage.setItem(STORAGE_KEY, normLang(lang3)); }catch(e){}
  }

  function getLang(){
    return readStoredLang() || getBrowserLang() || "FR";
  }

  function notifyLocaleChanged(){
    try{ window.dispatchEvent(new Event("po:locale-changed")); }catch(e){}
  }

  function setSlotText(root, slot, txt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (el) el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (el) el.innerHTML = clampStr(html);
  }

  function setSlotImgSrc(root, slot, src, alt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.setAttribute("src", clampStr(src));
    el.setAttribute("alt", clampStr(alt));
  }

  function renderListInto(root, slot, items){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.innerHTML = "";
    (items || []).forEach(function(item){
      var li = document.createElement("li");
      li.textContent = clampStr(item);
      el.appendChild(li);
    });
  }

  function renderWordBlocks(root, slot, blocks){
    var host = root.querySelector("[data-po-slot='" + slot + "']");
    if (!host) return;
    host.innerHTML = "";
    (blocks || []).forEach(function(b){
      var wrap = document.createElement("div");
      wrap.className = "po-axis-wb";
      var h = document.createElement("div");
      h.className = "po-axis-wb__h";
      h.textContent = clampStr((b || {}).head || "");
      var t = document.createElement("div");
      t.className = "po-axis-wb__t";
      t.textContent = clampStr((b || {}).text || "");
      wrap.appendChild(h);
      wrap.appendChild(t);
      host.appendChild(wrap);
    });
  }

  var CONTENT = {
    FR: {
      title: "Respiration d’Or",
      kicker: "Extrait du <em>Katûpirsia&nbsp;9 — Àṣẹxel’Or</em><br />(Phases dynamiques du réel et lecture systémique du Souffle d’Or)",
      h_def: "Définition opérative",
      chips: ["Idéogramme conceptuel", "Idéogramme fonctionnel"],
      chip_urls: [CONCEPT_URL, FUNCTION_URL],
      def_short: "Cycle universel d’inspiration / expiration ; équilibration du réel.",
      def_long: "<p><span class=\"notranslate\" translate=\"no\">Respiration d’Or</span> désigne, dans <em>Katûpirsia&nbsp;9</em>, l’une des phases dynamiques du réel. Le corpus la formule ainsi : « …elles pulsent lentement, dans une respiration d’or. » ; il en donne le sens opératif : « cycle universel d’inspiration / expiration ; équilibration du réel ».</p><p>Le manuscrit la prolonge par une formule récurrente, <span class=\"notranslate\" translate=\"no\">Respiration du cosmos en Or</span>, dont le sens est explicite : « vision unitaire : l’univers respire selon le φ vivant ». La respiration d’or ne nomme donc pas un simple apaisement, mais la tenue cyclique par laquelle le réel inspire, expire et se rééquilibre.</p><p>Dans la lecture systémique intégrée, <span class=\"notranslate\" translate=\"no\">Respiration d’Or</span> appartient au plan cosmique, avec <span class=\"notranslate\" translate=\"no\">Battement d’Or</span>, <span class=\"notranslate\" translate=\"no\">Cycle d’Or</span> et <span class=\"notranslate\" translate=\"no\">Gravité d’Or</span>. Elle participe à la régulation du Δτ, à l’équilibre gravitationnel et au rythme universel.</p><p>Dans la logique du corpus, elle nomme ainsi le cycle complet du <span class=\"notranslate\" translate=\"no\">Souffle d’Or</span> à l’échelle cosmique : non plus la seule pulsation, mais l’alternance entière par laquelle l’univers se maintient en cohérence respirante.</p>",
      h_features: "Dynamiques opératives",
      h_questions: "Applications / repères",
      hint_fold: "déplier",
      h_family: "Liens systémiques",
      h_wordbuild: "Construction du terme",
      features: [
        "Phase dynamique du réel : la respiration d’or appartient aux mouvements respiratoires du cosmos.",
        "Cycle universel d’inspiration / expiration : elle nomme la tenue complète du souffle à l’échelle cosmique.",
        "Équilibration du réel : le cycle respiratoire réajuste le monde sans l’immobiliser.",
        "Vision unitaire : l’univers respire selon le φ vivant.",
        "Plan cosmique : dans la lecture systémique, elle participe à la régulation du Δτ, à l’équilibre gravitationnel et au rythme universel."
      ],
      questions: [
        "Le mouvement observé relève-t-il d’une simple alternance, ou d’un cycle vivant d’inspiration et d’expiration ?",
        "Où le réel se rééquilibre-t-il ici par respiration plutôt que par fixité ?",
        "Quel signe indique la continuité du souffle : reprise, détente, dilatation, retour à la cohérence ?",
        "La respiration perçue engage-t-elle seulement un plan local, ou une relation plus vaste entre rythme, lumière et temps ?"
      ],
      example_box: "<div><strong>Ex.</strong> Dans une lecture posœnnoïale, lorsqu’un champ, une forme ou un rythme se réaccordent par alternance respirante plutôt que par arrêt, cette reprise peut être lue comme une respiration d’or.</div>",
      family_1: "<p><strong>Liens internes :</strong> <span>Respiration d’Or</span> appartient au plan cosmique de la grammaire dorée, avec <span>Battement d’Or</span>, <span>Cycle d’Or</span> et <span>Gravité d’Or</span>. Elle se rapporte directement au <span>Souffle d’Or</span>, dont elle constitue le cycle complet.</p>",
      family_2: "<p><strong>Fonction systémique :</strong> dans le manuscrit, la formule <span>Respiration du cosmos en Or</span> explicite sa portée : l’univers respire selon le φ vivant. La respiration d’or vaut ainsi comme équilibration du réel et comme modulation cosmique du Δτ.</p>",
      word_blocks: [
        { head: "1) Respiration", text: "Alternance d’inspiration et d’expiration, cycle complet par lequel un champ demeure vivant et cohérent." },
        { head: "2) d’Or", text: "Rapport au Souffle d’Or, au φ vivant et à la loi respiratoire qui ajuste le réel." },
        { head: "3) Ensemble", text: "L’expression nomme le cycle complet du Souffle : l’univers inspire, expire et se rééquilibre selon une respiration cosmique du juste." }
      ],
      word_notes: [
        "Entrée canonique maintenue en français dans toutes les langues d’interface.",
        "Plan principal : cosmique.",
        "Fonction : cycle universel d’inspiration / expiration ; équilibration du réel."
      ],
      cta_translate: "Proposer une traduction du concept",
      cta_aria: "Proposer une traduction — Lexique simplifié",
      langbar_aria: "Choix de langue"
    },
    EN: {
      title: "Respiration d’Or",
      kicker: "Excerpt from <em>Katûpirsia&nbsp;9 — Àṣẹxel’Or</em><br />(Dynamic phases of reality and systemic reading of Souffle d’Or)",
      h_def: "Operative definition",
      chips: ["Conceptual ideogram", "Functional ideogram"],
      chip_urls: [CONCEPT_URL, FUNCTION_URL],
      def_short: "Universal cycle of inhalation / exhalation; equilibration of reality.",
      def_long: "<p><span class=\"notranslate\" translate=\"no\">Respiration d’Or</span> designates, in <em>Katûpirsia&nbsp;9</em>, one of the dynamic phases of reality. The corpus formulates it as follows: “...they pulse slowly, in a respiration d’or”; it gives its operative sense as: “universal cycle of inhalation / exhalation; equilibration of reality.”</p><p>The manuscript extends it with a recurrent formula, <span class=\"notranslate\" translate=\"no\">Respiration du cosmos en Or</span>, whose meaning is explicit: “unitary vision: the universe breathes according to the living φ.” <span class=\"notranslate\" translate=\"no\">Respiration d’Or</span> therefore does not name a simple soothing state, but the cyclical bearing through which reality inhales, exhales, and rebalances itself.</p><p>In the integrated systemic reading, <span class=\"notranslate\" translate=\"no\">Respiration d’Or</span> belongs to the cosmic plane, together with <span class=\"notranslate\" translate=\"no\">Battement d’Or</span>, <span class=\"notranslate\" translate=\"no\">Cycle d’Or</span>, and <span class=\"notranslate\" translate=\"no\">Gravité d’Or</span>. It takes part in the regulation of Δτ, in gravitational balance, and in universal rhythm.</p><p>Within the logic of the corpus, it thus names the complete cycle of <span class=\"notranslate\" translate=\"no\">Souffle d’Or</span> at the cosmic scale: no longer the sole pulsation, but the whole alternation through which the universe maintains itself in breathing coherence.</p>",
      h_features: "Operative dynamics",
      h_questions: "Applications / markers",
      hint_fold: "expand",
      h_family: "Systemic links",
      h_wordbuild: "Construction of the term",
      features: [
        "Dynamic phase of reality: Respiration d’Or belongs to the respiratory movements of the cosmos.",
        "Universal cycle of inhalation / exhalation: it names the complete bearing of breath at the cosmic scale.",
        "Equilibration of reality: the respiratory cycle readjusts the world without freezing it.",
        "Unitary vision: the universe breathes according to the living φ.",
        "Cosmic plane: within the systemic reading, it participates in the regulation of Δτ, gravitational balance, and universal rhythm."
      ],
      questions: [
        "Does the observed movement belong to a mere alternation, or to a living cycle of inhalation and exhalation?",
        "Where does reality rebalance itself here through respiration rather than through fixity?",
        "What sign indicates the continuity of breath: resumption, release, dilation, return to coherence?",
        "Does the perceived respiration engage only a local plane, or a wider relation between rhythm, light, and time?"
      ],
      example_box: "<div><strong>Ex.</strong> In a posœnnoïal reading, when a field, form, or rhythm retunes itself through breathing alternation rather than through stoppage, that resumption may be read as a respiration d’or.</div>",
      family_1: "<p><strong>Internal links:</strong> <span>Respiration d’Or</span> belongs to the cosmic plane of the golden grammar, together with <span>Battement d’Or</span>, <span>Cycle d’Or</span>, and <span>Gravité d’Or</span>. It relates directly to <span>Souffle d’Or</span>, of which it forms the complete cycle.</p>",
      family_2: "<p><strong>Systemic function:</strong> in the manuscript, the formula <span>Respiration du cosmos en Or</span> clarifies its scope: the universe breathes according to the living φ. <span>Respiration d’Or</span> thus acts as equilibration of reality and as cosmic modulation of Δτ.</p>",
      word_blocks: [
        { head: "1) Respiration", text: "Alternation of inhalation and exhalation, the complete cycle through which a field remains living and coherent." },
        { head: "2) d’Or", text: "Relation to Souffle d’Or, to the living φ, and to the respiratory law that readjusts reality." },
        { head: "3) Whole term", text: "The expression names the complete cycle of the Breath: the universe inhales, exhales, and rebalances itself according to a cosmic respiration of the just." }
      ],
      word_notes: [
        "Canonical entry kept in French across all interface languages.",
        "Main plane: cosmic.",
        "Function: universal cycle of inhalation / exhalation; equilibration of reality."
      ],
      cta_translate: "Suggest a translation of the concept",
      cta_aria: "Suggest a translation — Simplified lexicon",
      langbar_aria: "Language selector"
    },
    ES: {
      title: "Respiration d’Or",
      kicker: "Extracto de <em>Katûpirsia&nbsp;9 — Àṣẹxel’Or</em><br />(Fases dinámicas de lo real y lectura sistémica de Souffle d’Or)",
      h_def: "Definición operativa",
      chips: ["Ideograma conceptual", "Ideograma funcional"],
      chip_urls: [CONCEPT_URL, FUNCTION_URL],
      def_short: "Ciclo universal de inspiración / expiración; equilibración de lo real.",
      def_long: "<p><span class=\"notranslate\" translate=\"no\">Respiration d’Or</span> designa, en <em>Katûpirsia&nbsp;9</em>, una de las fases dinámicas de lo real. El corpus la formula así: «… pulsan lentamente, en una respiration d’or.»; y le da este sentido operativo: «ciclo universal de inspiración / expiración; equilibración de lo real».</p><p>El manuscrito la prolonga mediante una fórmula recurrente, <span class=\"notranslate\" translate=\"no\">Respiration du cosmos en Or</span>, cuyo sentido es explícito: «visión unitaria: el universo respira según el φ viviente». <span class=\"notranslate\" translate=\"no\">Respiration d’Or</span> no nombra entonces un simple apaciguamiento, sino la tenida cíclica por la cual lo real inspira, expira y se reequilibra.</p><p>En la lectura sistémica integrada, <span class=\"notranslate\" translate=\"no\">Respiration d’Or</span> pertenece al plano cósmico, junto con <span class=\"notranslate\" translate=\"no\">Battement d’Or</span>, <span class=\"notranslate\" translate=\"no\">Cycle d’Or</span> y <span class=\"notranslate\" translate=\"no\">Gravité d’Or</span>. Participa en la regulación de Δτ, en el equilibrio gravitacional y en el ritmo universal.</p><p>En la lógica del corpus, nombra así el ciclo completo de <span class=\"notranslate\" translate=\"no\">Souffle d’Or</span> a escala cósmica: ya no la sola pulsación, sino la alternancia entera por la cual el universo se mantiene en coherencia respirante.</p>",
      h_features: "Dinámicas operativas",
      h_questions: "Aplicaciones / referencias",
      hint_fold: "desplegar",
      h_family: "Vínculos sistémicos",
      h_wordbuild: "Construcción del término",
      features: [
        "Fase dinámica de lo real: Respiration d’Or pertenece a los movimientos respiratorios del cosmos.",
        "Ciclo universal de inspiración / expiración: nombra la tenida completa del soplo a escala cósmica.",
        "Equilibración de lo real: el ciclo respiratorio reajusta el mundo sin inmovilizarlo.",
        "Visión unitaria: el universo respira según el φ viviente.",
        "Plano cósmico: en la lectura sistémica, participa en la regulación de Δτ, en el equilibrio gravitacional y en el ritmo universal."
      ],
      questions: [
        "¿El movimiento observado pertenece a una simple alternancia, o a un ciclo vivo de inspiración y expiración?",
        "¿Dónde se reequilibra aquí lo real por respiración y no por fijación?",
        "¿Qué signo indica la continuidad del soplo: reanudación, distensión, dilatación, retorno a la coherencia?",
        "¿La respiración percibida compromete solo un plano local, o una relación más amplia entre ritmo, luz y tiempo?"
      ],
      example_box: "<div><strong>Ej.</strong> En una lectura posœnnoïal, cuando un campo, una forma o un ritmo se reajustan por alternancia respirante y no por detención, esa retomada puede leerse como una respiration d’or.</div>",
      family_1: "<p><strong>Vínculos internos:</strong> <span>Respiration d’Or</span> pertenece al plano cósmico de la gramática dorada, junto con <span>Battement d’Or</span>, <span>Cycle d’Or</span> y <span>Gravité d’Or</span>. Se relaciona directamente con <span>Souffle d’Or</span>, del cual constituye el ciclo completo.</p>",
      family_2: "<p><strong>Función sistémica:</strong> en el manuscrito, la fórmula <span>Respiration du cosmos en Or</span> aclara su alcance: el universo respira según el φ viviente. <span>Respiration d’Or</span> vale así como equilibración de lo real y como modulación cósmica de Δτ.</p>",
      word_blocks: [
        { head: "1) Respiration", text: "Alternancia de inspiración y expiración, ciclo completo por el cual un campo permanece vivo y coherente." },
        { head: "2) d’Or", text: "Relación con Souffle d’Or, con el φ viviente y con la ley respiratoria que reajusta lo real." },
        { head: "3) Conjunto", text: "La expresión nombra el ciclo completo del Soplo: el universo inspira, expira y se reequilibra según una respiración cósmica de lo justo." }
      ],
      word_notes: [
        "Entrada canónica mantenida en francés en todas las lenguas de interfaz.",
        "Plano principal: cósmico.",
        "Función: ciclo universal de inspiración / expiración; equilibración de lo real."
      ],
      cta_translate: "Proponer une traduction du concept",
      cta_aria: "Proponer una traducción — Léxico simplificado",
      langbar_aria: "Selector de idioma"
    }
  };

  function updateButtons(root, lang){
    var btns = root.querySelectorAll('.po-langbtn');
    Array.prototype.forEach.call(btns, function(btn){
      var active = btn.getAttribute('data-po-lang') === lang;
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (btn.classList && btn.classList.toggle) btn.classList.toggle('is-active', active);
    });
    var bar = root.querySelector('.po-langbar');
    if (bar){
      var T = CONTENT[lang] || CONTENT.FR;
      if (T.langbar_aria) bar.setAttribute('aria-label', T.langbar_aria);
    }
  }

  function wireButtons(root){
    if (root.__po_lang_bound) return;
    root.__po_lang_bound = true;
    var btns = root.querySelectorAll('.po-langbtn');
    Array.prototype.forEach.call(btns, function(btn){
      btn.addEventListener('click', function(){
        var lang = normLang(btn.getAttribute('data-po-lang') || 'FR');
        applyLangEverywhere(lang);
      });
    });
  }

  /* ============================================================================
     AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
  ============================================================================ */

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    activeKey: ""
  };

  var AUDIO_UI = {
    FR: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    EN: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    ES: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function audioUI(lang){
    return AUDIO_UI[normLang(lang)] || AUDIO_UI.FR;
  }

  function ensureAudioStyles(){
    if (document.getElementById("po-axis-audio-styles-respiration-d-or")) return;
    var style = document.createElement("style");
    style.id = "po-axis-audio-styles-respiration-d-or";
    style.textContent = ""
      + ".po-axis-audio-wrap{display:flex;justify-content:center;align-items:center;margin:10px 0 12px;}"
      + ".po-axis-audio-btn{appearance:none;border:1px solid rgba(0,0,0,.14);background:rgba(255,255,255,.72);color:inherit;border-radius:999px;padding:7px 12px;font:inherit;font-size:12px;line-height:1;cursor:pointer;}"
      + ".po-axis-audio-btn.is-playing{border-color:rgba(184,134,11,.55);box-shadow:0 0 0 1px rgba(184,134,11,.18);font-weight:700;}"
      + ".po-lex-summary .po-axis-audio-btn{margin-left:auto;flex:0 0 auto;}"
      + ".po-lex-summary .po-lex-summary__title{margin-right:auto;}";
    document.head.appendChild(style);
  }

  function stopAudio(){
    if (PO_AUDIO_SYNTH){
      try{ PO_AUDIO_SYNTH.cancel(); }catch(e){}
    }
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.activeKey = "";
    resetAudioButtons();
  }

  function resetAudioButtons(root){
    var scope = root || document;
    var btns = scope.querySelectorAll(".po-axis-audio-btn");
    Array.prototype.forEach.call(btns, function(btn){
      btn.classList.remove("is-playing");
      var lang = normLang(btn.getAttribute("data-po-audio-lang") || getLang());
      var ui = audioUI(lang);
      var role = btn.getAttribute("data-po-audio-role");
      btn.textContent = role === "general" ? ui.general : ui.block;
    });
  }

  function createAudioButton(role, index, lang){
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-axis-audio-btn";
    btn.setAttribute("data-po-audio-role", role);
    btn.setAttribute("data-po-audio-lang", normLang(lang));
    if (role === "block") btn.setAttribute("data-po-audio-index", String(index));
    btn.textContent = (role === "general" ? audioUI(lang).general : audioUI(lang).block);
    return btn;
  }

  function ensureAudioButtons(root, lang){
    if (!root) return;
    ensureAudioStyles();

    var panel = root.querySelector(".po-lex-panel");
    if (panel){
      var generalWrap = root.querySelector(".po-axis-audio-wrap[data-po-audio-role='general']");
      if (!generalWrap){
        generalWrap = document.createElement("div");
        generalWrap.className = "po-axis-audio-wrap";
        generalWrap.setAttribute("data-po-audio-role", "general");
        generalWrap.appendChild(createAudioButton("general", -1, lang));

        var meta = root.querySelector(".po-axis-meta");
        var defShort = root.querySelector("[data-po-slot='def_short']");
        var firstDetails = root.querySelector(".po-lex-details");
        if (meta && meta.parentNode === panel && meta.nextSibling){
          panel.insertBefore(generalWrap, meta.nextSibling);
        } else if (defShort && defShort.parentNode === panel){
          panel.insertBefore(generalWrap, defShort);
        } else if (firstDetails && firstDetails.parentNode === panel){
          panel.insertBefore(generalWrap, firstDetails);
        } else {
          panel.appendChild(generalWrap);
        }
      }
      var gbtn = generalWrap.querySelector(".po-axis-audio-btn");
      if (gbtn){
        gbtn.setAttribute("data-po-audio-lang", normLang(lang));
        gbtn.textContent = audioUI(lang).general;
      }
    }

    var details = root.querySelectorAll(".po-lex-details");
    Array.prototype.forEach.call(details, function(det, index){
      var summary = det.querySelector(".po-lex-summary");
      if (!summary) return;
      var btn = summary.querySelector(".po-axis-audio-btn[data-po-audio-role='block']");
      if (!btn){
        btn = createAudioButton("block", index, lang);
        summary.appendChild(btn);
      }
      btn.setAttribute("data-po-audio-index", String(index));
      btn.setAttribute("data-po-audio-lang", normLang(lang));
      btn.textContent = audioUI(lang).block;
    });

    bindAudioButtons(root);
  }

  function bindAudioButtons(root){
    if (!root || root.__po_audio_bound) return;
    root.__po_audio_bound = true;

    root.addEventListener("click", function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest(".po-axis-audio-btn") : null;
      if (!btn || !root.contains(btn)) return;
      ev.preventDefault();
      ev.stopPropagation();

      var role = btn.getAttribute("data-po-audio-role");
      var index = parseInt(btn.getAttribute("data-po-audio-index") || "-1", 10);
      var lang = normLang(btn.getAttribute("data-po-audio-lang") || getLang());

      if (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === (role + ":" + index)){
        stopAudio();
        return;
      }
      startAudio(root, role, index, lang);
    }, true);
  }

  function nodeText(node){
    return clampStr((node && (node.innerText || node.textContent)) || "")
      .replace(/\s+/g, " ")
      .replace(/Écouter le texte|Listen to the text|Escuchar el texto|Écouter ce bloc|Listen to this section|Escuchar este bloque|Arrêter la lecture|Stop playback|Detener la lectura/g, " ")
      .trim();
  }

  function getGeneralText(root){
    var parts = [];
    ["title", "kicker", "h_def", "def_short", "def_long"].forEach(function(slot){
      var el = root.querySelector("[data-po-slot='" + slot + "']");
      var txt = nodeText(el);
      if (txt) parts.push(txt);
    });
    return parts.join(" ");
  }

  function getBlockText(detail){
    if (!detail) return "";
    var summary = detail.querySelector(".po-lex-summary");
    var titleNode = summary ? summary.querySelector(".po-lex-summary__title") : null;
    var title = nodeText(titleNode);
    var clone = detail.cloneNode(true);
    var audioBtns = clone.querySelectorAll(".po-axis-audio-btn");
    Array.prototype.forEach.call(audioBtns, function(btn){ if (btn.parentNode) btn.parentNode.removeChild(btn); });
    var summaryClone = clone.querySelector(".po-lex-summary");
    if (summaryClone && summaryClone.parentNode) summaryClone.parentNode.removeChild(summaryClone);
    var body = nodeText(clone);
    return (title ? title + ". " : "") + body;
  }

  function splitSpeechText(text, maxLen){
    var cleaned = clampStr(text).replace(/\s+/g, " ").trim();
    if (!cleaned) return [];
    var sentences = cleaned.match(/[^.!?]+[.!?]?/g) || [cleaned];
    var out = [];
    var cur = "";
    var limit = maxLen || 210;

    sentences.forEach(function(s){
      s = clampStr(s).trim();
      if (!s) return;
      if ((cur + " " + s).trim().length <= limit){
        cur = (cur ? cur + " " : "") + s;
        return;
      }
      if (cur) out.push(cur.trim());
      if (s.length <= limit){
        cur = s;
        return;
      }
      var words = s.split(/\s+/);
      cur = "";
      words.forEach(function(w){
        if (!w) return;
        if ((cur + " " + w).trim().length <= limit){
          cur = (cur ? cur + " " : "") + w;
        } else {
          if (cur) out.push(cur.trim());
          cur = w;
        }
      });
    });

    if (cur) out.push(cur.trim());
    return out;
  }

  function setActiveAudioButton(root, role, index, lang){
    resetAudioButtons(root);
    var selector = role === "general"
      ? ".po-axis-audio-btn[data-po-audio-role='general']"
      : ".po-axis-audio-btn[data-po-audio-role='block'][data-po-audio-index='" + index + "']";
    var btn = root.querySelector(selector);
    if (!btn) return;
    btn.classList.add("is-playing");
    btn.setAttribute("data-po-audio-lang", normLang(lang));
    btn.textContent = audioUI(lang).stop;
  }

  function buildAudioUnits(root, role, startIndex){
    var units = [];
    if (role === "general"){
      var generalText = getGeneralText(root);
      if (generalText) units.push({ role: "general", index: -1, text: generalText });
      var detailsAll = root.querySelectorAll(".po-lex-details");
      Array.prototype.forEach.call(detailsAll, function(det, idx){
        var txt = getBlockText(det);
        if (txt) units.push({ role: "block", index: idx, text: txt, detail: det });
      });
      return units;
    }

    var details = root.querySelectorAll(".po-lex-details");
    for (var i = startIndex; i < details.length; i++){
      var text = getBlockText(details[i]);
      if (text) units.push({ role: "block", index: i, text: text, detail: details[i] });
    }
    return units;
  }

  function pickVoice(lang){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_SYNTH.getVoices) return null;
    var voices = PO_AUDIO_SYNTH.getVoices() || [];
    if (!voices.length) return null;
    var targets = normLang(lang) === "EN" ? ["en"] : (normLang(lang) === "ES" ? ["es"] : ["fr"]);
    for (var i = 0; i < voices.length; i++){
      var vl = clampStr(voices[i].lang).toLowerCase();
      for (var j = 0; j < targets.length; j++){
        if (vl.indexOf(targets[j]) === 0) return voices[i];
      }
    }
    return voices[0] || null;
  }

  function speakCurrentChunk(lang){
    if (!PO_AUDIO_SYNTH) return;
    if (!PO_AUDIO_STATE.chunks.length){
      advanceAudioUnit(lang);
      return;
    }

    var chunk = PO_AUDIO_STATE.chunks.shift();
    var utter = new SpeechSynthesisUtterance(chunk);
    var voice = pickVoice(lang);
    if (voice) utter.voice = voice;
    utter.lang = normLang(lang) === "EN" ? "en-US" : (normLang(lang) === "ES" ? "es-ES" : "fr-FR");

    utter.onend = function(){ speakCurrentChunk(lang); };
    utter.onerror = function(){ speakCurrentChunk(lang); };

    try{ PO_AUDIO_SYNTH.speak(utter); }catch(e){ advanceAudioUnit(lang); }
  }

  function advanceAudioUnit(lang){
    PO_AUDIO_STATE.unitPos += 1;
    if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){
      stopAudio();
      return;
    }

    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    if (unit.role === "block" && unit.detail){
      try{ unit.detail.open = true; }catch(e){}
    }
    PO_AUDIO_STATE.activeKey = unit.role + ":" + unit.index;
    setActiveAudioButton(PO_AUDIO_STATE.root, unit.role, unit.index, lang);
    PO_AUDIO_STATE.chunks = splitSpeechText(unit.text, 210);
    speakCurrentChunk(lang);
  }

  function startAudio(root, role, index, lang){
    if (!PO_AUDIO_SYNTH) return;
    stopAudio();
    ensureAudioButtons(root, lang);

    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildAudioUnits(root, role, index);
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.activeKey = "";
    if (!PO_AUDIO_STATE.units.length){
      stopAudio();
      return;
    }
    advanceAudioUnit(lang);
  }

  function initAudioEverywhere(lang){
    var roots = document.querySelectorAll(ROOT_SEL);
    Array.prototype.forEach.call(roots, function(root){
      ensureAudioButtons(root, lang);
      resetAudioButtons(root);
    });
  }

  function renderRoot(root, lang){
    var T = CONTENT[lang] || CONTENT.FR;
    setSlotText(root, 'title', T.title);
    setSlotHTML(root, 'kicker', T.kicker);
    setSlotImgSrc(root, 'title_img', T.chip_urls[0], T.title);
    setSlotText(root, 'h_def', T.h_def);
    setSlotText(root, 'chip_1', T.chips[0]);
    setSlotText(root, 'chip_2', T.chips[1]);
    setSlotImgSrc(root, 'chip_1_img', T.chip_urls[0], T.chips[0]);
    setSlotImgSrc(root, 'chip_2_img', T.chip_urls[1], T.chips[1]);
    setSlotText(root, 'def_short', T.def_short);
    setSlotHTML(root, 'def_long', T.def_long);
    setSlotText(root, 'h_features', T.h_features);
    setSlotText(root, 'h_questions', T.h_questions);
    setSlotText(root, 'hint_fold', T.hint_fold);
    setSlotText(root, 'hint_fold2', T.hint_fold);
    setSlotText(root, 'h_family', T.h_family);
    setSlotText(root, 'hint_fold3', T.hint_fold);
    setSlotText(root, 'h_wordbuild', T.h_wordbuild);
    setSlotText(root, 'hint_fold4', T.hint_fold);
    renderListInto(root, 'features', T.features);
    renderListInto(root, 'questions', T.questions);
    setSlotHTML(root, 'example_box', T.example_box);
    setSlotHTML(root, 'family_1', T.family_1);
    setSlotHTML(root, 'family_2', T.family_2);
    renderWordBlocks(root, 'wordbuild_blocks', T.word_blocks);
    renderListInto(root, 'wordbuild_notes', T.word_notes);
    setSlotText(root, 'cta_translate', T.cta_translate);

    var cta = root.querySelector('.po-axis-breath-link');
    if (cta && T.cta_aria) cta.setAttribute('aria-label', T.cta_aria);

    updateButtons(root, lang);
    wireButtons(root);
  }

  function applyLangEverywhere(lang3){
    var lang = normLang(lang3);
    storeLang(lang);
    var roots = document.querySelectorAll(ROOT_SEL);
    Array.prototype.forEach.call(roots, function(root){ renderRoot(root, lang); });
    initAudioEverywhere(lang);
    notifyLocaleChanged();
  }

  function init(){ applyLangEverywhere(getLang()); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.PoKatupirsia9RespirationDOrTextsFR_EN_ES_20260326 = {
    init: init,
    setLang: applyLangEverywhere,
    getLang: getLang,
    normLang: normLang,
    stopAudio: stopAudio
  };
})();
